import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { EventService } from "../event.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ImageCroppedEvent } from 'ngx-image-cropper';
// import Swal from "sweetalert2";
@Component({
  selector: 'app-duplicate-event',
  templateUrl: './duplicate-event.component.html',
  styleUrls: ['./duplicate-event.component.css']
})
export class DuplicateEventComponent  implements OnInit {

  planForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  bannerImg:"";
  timeZoneList = [
    "America/New_York",
    "America/Los_Angeles",
    "America/Phoenix",
    "America/Chicago",
    "America/Denver",
    "America/Anchorage",
    "Pacific/Honolulu",
  ];
  temp: any;

  desciptionName: string;
  planRequest = {
    title: null,
    date: null,
    time: null,
    link: [],
    eventEpoch: null,
    description:null,
    image:null,
    courseId:null
  }
  eventId:any;
  isUploading:boolean=true;
  ImageUploadError:boolean = false;
  selectedFile: File;
  uploadCourseImage: any;
  courseList:[];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private EventService: EventService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.eventId = this.route.snapshot.params["event_id"];
    this.initialiseForms();
    this.planForm.reset();
    this.getplanById();
    this.getCoureList();
  }
  eventResponse:any;
  getplanById() {
    this.spinner.show(); 
    let query = "eventId=" + this.eventId;
    this.EventService.getEventById(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.eventResponse = res.data.eventList[0];
        this.updateForm();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }
  showImageError:boolean = true;
ImageUpload:boolean = false;

onFileChanged(event) {
  this.selectedFile = event.target.files[0];
  this.uploadCourseImage = this.selectedFile.name;
  this.spinner.show();
  this.EventService.uploadImage(this.selectedFile).subscribe(data => {
    if (data["status"] === "Success") {
      Swal.fire("Success", "Image uploaded successfully!", "success");
      this.spinner.hide();
      this.uploadCourseImage = data.url;
      this.planForm.controls['image'].setValue(this.uploadCourseImage);
      this.showImageError = false;
      this.ImageUpload = true;
      
    } else {
      this.spinner.show();
      Swal.fire({
        type: "error",
        title: "Error",
        text: data.msg
      });
    }
  });
}
  
  updateForm() {

    this.planForm.patchValue({
      title: this.eventResponse["title"],
      link: this.eventResponse["link"],
      description:this.eventResponse["description"],
      image:this.eventResponse['image'],
      courseId:this.eventResponse['courseId']

    });
    if(this.eventResponse['courseId'] == null) {
      this.planForm.controls['courseId'].setValue("");
    }
    if(this.eventResponse['image']) {
      this.uploadCourseImage = this.eventResponse['image'];
      this.ImageUpload = true;
      this.ImageUploadError = false
    }else {
      this.ImageUpload = false;
      this.ImageUploadError = true

    }
    this.uploadCourseImage = this.eventResponse['image'];
    this.ImageUpload = true;
    this.SelectDate =this.eventResponse["date"];

  }

 

//   <mat-form-field class="mat-form w-100">
//   <mat-label>Search by Status</mat-label>
//   <mat-select [(value)]="searchUserStatus">
//     <mat-option value="all">All Users</mat-option>
//     <mat-option value="active">Active</mat-option>
//     <mat-option value="blocked">Blocked</mat-option>
//     <!-- <mat-option value="suspended">Inactive</mat-option> -->
//   </mat-select>
// </mat-form-field>

  initialiseForms() {
    this.planForm = this.fb.group({
      date: ["", [Validators.required]],
      time: ["", [Validators.required]],
      title: ["", [Validators.required]],
      link: ["", [Validators.required]],
      courseId: [""],
      description: [, [Validators.required]],
      image:[""]

    });
  }
  SelectDate:string;
  onStartTimeChange(event) {

      let travelDay = this.planForm.value.date.getDate();
      if (travelDay < 10) travelDay = "0" + travelDay;
      let travelMonth = this.planForm.value.date.getMonth() + 1;
      if (travelMonth < 10) travelMonth = "0" + travelMonth;
      let travelYear = this.planForm.value.date.getFullYear();
      this.SelectDate =  travelYear+'-'+travelMonth+'-'+travelDay;
     
  }
  
  Addplan() {
    this.formSubmitted = true;
    if (this.planForm.valid) {
      this.spinner.show();
      this.SelectDate = "";
      this.planRequest.title = this.planForm.value.title;
      let travelDay = this.planForm.value.date.getDate();
      if (travelDay < 10) travelDay = "0" + travelDay;
      let travelMonth = this.planForm.value.date.getMonth() + 1;
      if (travelMonth < 10) travelMonth = "0" + travelMonth;
      let travelYear = this.planForm.value.date.getFullYear();
      this.SelectDate =  travelYear+'-'+travelMonth+'-'+travelDay;
      let date = this.SelectDate +"T"+this.planForm.value.time;
  
      var unix_seconds = ((new Date(date)).getTime()) /1000;
      this.planRequest.eventEpoch = unix_seconds;
      this.planRequest.title = this.planForm.value.title;
      this.planRequest.date = this.SelectDate;
      this.planRequest.link = this.planForm.value.link;
      this.planRequest.time = this.planForm.value.time;
      this.planRequest.description = this.planForm.value.description;
      this.planRequest.courseId  = this.planForm.value.courseId;

      if(this.planForm.value.courseId){
        this.planRequest.courseId  = this.planForm.value.courseId;
      }else {
        delete this.planRequest['courseId']
      }
      if(this.planForm.value.image) {
        this.planRequest.image = this.planForm.value.image;
      }else {
        delete this.planRequest.image;
      }
      this.EventService.saveEvent(this.planRequest).subscribe(data => {
        if ((data["message"] = "Success")) {
          this.spinner.hide();
          Swal.fire("Success", "Event created successfully!", "success");

          this.router.navigate(["/main/event-management/view-event"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, err => {
        this.spinner.hide();
      });
    }




  }
  getCoureList() {
    this.spinner.show();
    this.EventService.getCourseList().subscribe(res => {

      if ((res["message"] = "Success")) {
        this.courseList = res.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
  resetFeature() {
    this.featureList = [];
    this.planForm.controls['desciptionName'].setValue(" ");
    this.showDesciptionError = true;
  }
  cancel() {
    this.router.navigate(["/main/event-management/view-event"]);
  }
  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileChangeEvent(event: any): void {
    this.spinner.show();
    let file, img;
    if ((file = event.target.files[0]) && (file.type === "image/png" || file.type === "image/jpeg")) {
        img = new Image();
        this.imageChangedEvent = event;
    }
     else {
         
      }
      this.spinner.hide();
  }

  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}
removeImage(){
  this.uploadCourseImage ="";
  this.planForm.controls['image'].setValue(this.uploadCourseImage);
 }
save(): void {
  const  blob = this.b64toBlob(this.croppedImage);
  this.imageChangedEvent = null;
  this.spinner.show;
  this.EventService.uploadImageBlob(blob).subscribe(res => {
    this.spinner.hide;
      if (res['message'] == 'Success') {
          this.bannerImg = res['data'].original;
          this.planForm.controls['image'].setValue(this.bannerImg);
          //console.log('Image url',this.bannerImg)

      }
  });
}
imageCropped(event:  ImageCroppedEvent) {
  this.croppedImage = event.base64;
 // console.log(this.croppedImage,'CropImage')
}

imageLoaded() {
  // show cropper
}
cropperReady() {
  // cropper ready
}
loadImageFailed() {
  // show message
}
cancelCropper(): void {
  this.croppedImage = null;
  this.imageChangedEvent = null;
  this.isUploading = false;
  setTimeout(() => {
    /** spinner ends after 1 seconds */
    this.isUploading = true;
  }, 1000);
}
}

